import React from 'react';
import cn from 'classnames';

import { Icon } from 'components/shared/Icon';

import styles from './CompletedIcon.module.scss';

const CompletedIcon = ({
  className,
  iconClassName,
}: {
  className: any;
  iconClassName: any;
}) => (
  <div className={cn(styles.wrapper, className)}>
    <Icon className={cn(styles.icon, iconClassName)} name="checkMini" />
  </div>
);

export default React.memo(CompletedIcon) as any;
